var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4175 41.4457L26.1593 41.2895L25.9008 41.4452L13.2141 49.0877L13.2132 49.0883C11.2703 50.2643 8.8925 48.528 9.40419 46.3277L12.7669 31.8988L12.8353 31.605L12.6073 31.4075L1.38808 21.6861L1.3879 21.686C-0.327028 20.2014 0.597715 17.3913 2.8428 17.2127L2.84545 17.2125L17.6108 15.9591L17.911 15.9336L18.0288 15.6563L23.8065 2.0526L23.8073 2.05066C24.6752 -0.0168861 27.6423 -0.0168853 28.5102 2.05066L28.5109 2.05223L34.2886 15.6865L34.4063 15.9641L34.7067 15.9896L49.4721 17.243L49.4747 17.2432C51.7198 17.4218 52.6446 20.232 50.9296 21.7166L50.9294 21.7167L39.7102 31.438L39.4822 31.6356L39.5507 31.9294L42.9133 46.3583C43.425 48.5586 41.0472 50.2948 39.1043 49.1189L39.1041 49.1188L26.4175 41.4457Z",
    stroke: "#9392AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackStar);
export default __webpack_public_path__ + "static/media/FeedbackStar.98755c83587f739d41782a832def657c.svg";
export { ForwardRef as ReactComponent };